import { HTTPError } from 'ky';

export function isHttpError(error: unknown): error is HTTPError {
  return error instanceof HTTPError;
}

export function isHttpNotFoundError(error: unknown): error is HTTPError {
  return isHttpError(error) && error.response.status === 404;
}

export async function throwApiMessage(error: unknown): Promise<never> {
  if (isHttpError(error)) {
    const body = await error.response.json<{ message: string }>();
    throw new Error(body.message);
  }
  throw error;
}
